<script lang="ts">
  import type { LayoutData } from './$types'
  import '../app.css'
  import { ApiAlert, SetInitialTheme, StructuredData } from '@bond/components'
  import {
    PUBLIC_ENVIRONMENT,
    PUBLIC_BRUCE_PUBLIC_SITE_TLD,
  } from '$env/static/public'
  import SetPreferredCity from '$lib/components/SetPreferredCity.svelte'
  import { page } from '$app/stores'

  export let data: LayoutData
  $: ({ alert, origin, shouldIndex, url } = data)
</script>

<svelte:head>
  {#if PUBLIC_ENVIRONMENT === 'production' && shouldIndex}
    <meta name="robots" content="index, follow, nocache" />
  {:else}
    <meta name="robots" content="noindex" />
  {/if}
  <meta property="og:site_name" content="Bruce Studios" />
  <meta property="og:type" content="website" />
  <meta property="og:url" content={url} />
  <meta property="og:image" content={`${origin}/opengraph-image.jpg`} />
  <meta name="twitter:card" content="summary_large_card" />
  <meta name="twitter:image" content={`${origin}/twitter-image.jpg`} />
  <meta
    name="theme-color"
    media="(prefers-color-scheme: dark)"
    content="#272727"
  />
  <meta
    name="theme-color"
    media="(prefers-color-scheme: light)"
    content="#ffffff"
  />
  <link rel="canonical" href={url} />
  <SetInitialTheme />
  <SetPreferredCity />
</svelte:head>
<StructuredData
  schema={{
    '@type': 'WebSite',
    name: 'Bruce Studios',
    url: `https://www.${PUBLIC_BRUCE_PUBLIC_SITE_TLD}`,
  }}
/>
<slot />
{#if alert}
  <ApiAlert>
    {$page.route.id?.includes('auth')
      ? PUBLIC_ENVIRONMENT.toUpperCase()
      : alert}
  </ApiAlert>
{/if}
